import { connect } from 'react-redux';
import { getFormValues , reduxForm} from 'redux-form';
import React, {Component} from 'react';
import Grid from '@react/react-spectrum/Grid/js/Grid';
import GridColumn from '@react/react-spectrum/Grid/js/GridColumn';
import GridRow from '@react/react-spectrum/Grid/js/GridRow';
import Well from '@react/react-spectrum/Well';
import DataSection from '../../comps/DataSection/DataSection';
import Heading from '@react/react-spectrum/Heading';
import formFields from '../config/formFields';
import { Translate } from 'react-redux-i18n';
// import geoPolData from '../config/geoPolData';
import SaveNExit from './save_n_ext';

class CompanyInfo extends Component{ 


    constructor()
    {
        super();
        window.scrollTo(0,0);
        this.state = {
            sectionValidation : {}
        }
    }

    updateValidation = (name,value) => {
        let sectionValidation = this.state.sectionValidation;
        sectionValidation[name] = value;
        this.setState({sectionValidation:sectionValidation});
    }
    
    render(){
        
        if(!this.props.isSaveAndExit) {
            this.props.onValidateChange(Object.values(this.state.sectionValidation).every(Boolean));
            const formName = 'uplevelRenewal';
            return <div>
                <Grid>
                    <GridRow>
                        <GridColumn size={[12,10,8,8]} offsetSize={[0,1,2,2]}>
                            <GridRow>
                                <GridColumn >
                                    <Heading className = "textBold" variant="pageTitle"><Translate value="uplevelRenewal.ONBCompInfo" /></Heading>
                                    <p><Translate value="uplevelRenewal.ONBEnterCompDetails" /></p>
                                </GridColumn>
                            </GridRow>
                            <GridRow>
                                <GridColumn size={[12,4,4,4]} >
                                    <Heading variant="subtitle2"><Translate value="uplevelRenewal.basic_comp_info" /></Heading>
                                </GridColumn>
                            </GridRow>
                            <Well className="well">
                            <GridRow>
                                <GridColumn size={[12,6,6,6]} >
                                    {   
                                        ( (this.props.formStates.context==="Uplevel" && this.props.formStates["level"]==="Certified" && this.props.formStates["draftLevel"]==="Gold") || (this.props.formStates.context==="Renewal" && this.props.formStates["draftLevel"] != "Registered") ) ?
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section12} sectionName="section12" updateValidation={this.updateValidation}/>:
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section3} sectionName="section3" updateValidation={this.updateValidation}/>
                                    }
                                </GridColumn>
                                <GridColumn size={[12,6,6,6]} >
                                    
                                    {   
                                        ( (this.props.formStates.context==="Uplevel" && this.props.formStates["level"]==="Certified" && this.props.formStates["draftLevel"]==="Gold") || (this.props.formStates.context==="Renewal" && this.props.formStates["draftLevel"] != "Registered") ) ?
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section13} sectionName="section13" updateValidation={this.updateValidation}/>:
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section4} sectionName="section4" updateValidation={this.updateValidation}/>
                                    }

                                </GridColumn>
                            </GridRow>
                            </Well>
                            <br/>
                            <GridRow >
                                <GridColumn size={[12,4,4,4]}>
                                    <Heading variant="subtitle2"><Translate value="uplevelRenewal.location" /></Heading>
                                </GridColumn>
                            </GridRow>
                            <Well className="well">
                                <GridRow >
                                    <GridColumn size={[12,6,6,6]} >
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section5} sectionName="section5" updateValidation={this.updateValidation}/>
                                    </GridColumn>
                                    <GridColumn size={[12,6,6,6]} >
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section6} sectionName="section6" updateValidation={this.updateValidation}/>
                                    </GridColumn>
                                </GridRow>
                            </Well>
                            <br/>
                            <GridRow >
                                <GridColumn size={[12,4,4,4]}>
                                    <Heading variant="subtitle2"><Translate value="uplevelRenewal.ONBContsInfo" /></Heading>
                                </GridColumn>
                            </GridRow>
                            <Well className="well">
                                <GridRow >
                                    <GridColumn size={[12,6,6,6]} >
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section7} sectionName="section7" updateValidation={this.updateValidation}/>
                                    </GridColumn>
                                    <GridColumn size={[12,6,6,6]} >
                                        <DataSection formStates={this.props.formStates} form={formName} field={formFields.section8} sectionName="section8" updateValidation={this.updateValidation}/>
                                    </GridColumn>
                                </GridRow>
                            </Well>
                            <br/>
                            <GridRow >
                                <GridColumn size={[12,6,6,6]}>
                                    <DataSection formStates={this.props.formStates} form={formName} field={formFields.section18} sectionName="section18" updateValidation={this.updateValidation}/>
                                </GridColumn>
                            </GridRow>
                        </GridColumn>
                    </GridRow>
                </Grid>
                </div>
        }
        else {
            return <SaveNExit />
        }
    }
}

CompanyInfo = reduxForm({
    form:'uplevelRenewal',
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
  })(CompanyInfo);

function mapStateToProps(state) {
return {
        formStates: getFormValues('uplevelRenewal')(state), // here 'form' is the name you have given your redux form  
    }
}

export default connect(mapStateToProps)(CompanyInfo);